export default __webpack_public_path__ + "static/media/g2022-29.77ef11ab.jpeg";